export default __webpack_public_path__ + "static/media/spirit_locket_of_boreas.69c77c82.png";